const config = {
    baseURL: 'http://localhost/ehaazri/haazri-backend/',
    defaultHeaders: {
        'Content-Type': 'application/json'
    }
};

export default config;
